import {Catalog, FilterCatalog} from '../../common/types/common';
import {DisplaySummaryDTO} from '../loan/common/types/epics';

export const EMPTY_STRING: string = '';
export const EMPTY_NUMBER: number = 0;
export const AUTO_SAVE_DEBOUNCE_MIN_TIME: number = 200;
export const AUTO_SAVE_DEBOUNCE_TIME: number = 2000;
export const AUTO_SAVE_DELAY_LOADING: number = 2000;
export const LOADER_DELAY_LOADING: number = 700;
export const EMPTY_CATALOG: Catalog = {id: '', value: '', payload: ''} as Catalog;
export const GPS_INSTALLATION_STATUS_NOT_APPLICABLE: string = 'NotApplicable';
export const WITHOUT_ADVISOR_CATALOG: Catalog = {id: 'without-advisor', value: 'Sin Asesor', payload: ''} as Catalog;
export const RECORDS_COMPLETE_CATALOG: Catalog = {id: 'Complete', value: 'Completo'} as Catalog;
export const ALL_CATALOG: Catalog = {id: '', value: 'Todos', payload: ''} as Catalog;
export const EMPTY_FILTER_CATALOG: FilterCatalog = {id: '', name: '', count: 0} as FilterCatalog;
export const EMPTY_DISPLAY_VALUE: DisplaySummaryDTO = {value: 0, displayValue: ''} as DisplaySummaryDTO;
export const MAX_LENGTH_LADA_PHONE = 10;
export const MAX_LENGTH_LAND_LINE = 8;

const FLOAT_BUTTON = {
    CALCULATOR: {
        name: 'calculadora',
        icon: '/assets/images/common/calculator-icon.svg',
        alt: 'Calculadora',
        tooltip: 'Calculadora'
    },
    GENERATE_PDF: {
        name: 'generar pdf',
        icon: '/assets/images/common/pdf-icon-light.svg',
        alt: 'Generar PDF',
        tooltip: 'Generar PDF'
    },
    GENERATE_CSV: {
        name: 'generar csv',
        icon: '/assets/images/common/csv-icon-light.svg',
        alt: 'Generar CSV',
        tooltip: 'Generar CSV'
    },
    ADD_GROUP: {
        name: 'agregar dealer',
        icon: '/assets/images/admin/add-big-icon.svg',
        alt: 'Agregar dealer',
        tooltip: 'Agregar Dealer'
    },
    UPLOAD_FILE: {
        name: 'agregar archivo',
        icon: '/assets/images/admin/add-big-icon.svg',
        alt: 'Agregar archivo',
        tooltip: 'Agregar Archivo'
    },
    DOWNLOAD_FILE: {
        name: 'descargar archivo',
        icon: '/assets/images/common/download-icon.svg',
        alt: 'Descargar archivo',
        tooltip: 'Descargar Archivo'
    }
};

const FILE_LIST = {
    APPLICATION_CSV: 'text/csv',
    APPLICATION_PDF: 'application/pdf',
    PDF_ICON: 'pdf-icon.svg'
};

export {
    FLOAT_BUTTON,
    FILE_LIST
};
